import { h } from "omi";

import { IconProps } from "@/wc/components";

export function HomeLineIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={props.width} height={props.height} viewBox="0 0 17 18">
      <g clip-path="url(#clip0_3551_19596)">
        <path
          d="M5.59399 12.4158L10.9241 12.602M7.93578 3.00117L3.29426 6.35798C2.98399 6.58237 2.82886 6.69457 2.71492 6.83788C2.61398 6.96482 2.53706 7.10912 2.48792 7.26368C2.43244 7.43816 2.42576 7.6295 2.4124 8.01217L2.24407 12.8325C2.21801 13.5788 2.20498 13.9519 2.34026 14.2421C2.45926 14.4972 2.65599 14.7082 2.90226 14.8447C3.18223 14.9999 3.55537 15.0129 4.30165 15.039L12.0303 15.3089C12.7766 15.335 13.1497 15.348 13.4398 15.2127C13.695 15.0937 13.906 14.897 14.0425 14.6507C14.1977 14.3707 14.2107 13.9976 14.2368 13.2513L14.4051 8.43096C14.4185 8.04829 14.4251 7.85695 14.382 7.67903C14.3437 7.52142 14.2771 7.37211 14.1852 7.23843C14.0816 7.08752 13.9346 6.96478 13.6408 6.71929L9.24472 3.04688C9.017 2.85665 8.90314 2.76154 8.77513 2.72203C8.66218 2.68718 8.54199 2.68298 8.42688 2.70987C8.29642 2.74035 8.17621 2.82729 7.93578 3.00117Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3551_19596">
          <rect width="16" height="16" fill="white" transform="translate(0.660156 0.90332) rotate(2)" />
        </clipPath>
      </defs>
    </svg>
  );
}
